export default __webpack_public_path__ + "static/media/watching-microscope.9dc2a583.jpg";